"use client";

import { closeDrawer } from "@/src/store/slices/allDrawerSlice";
import { RootState } from "@/src/store/store";
import { Button, Drawer, useOverlayState } from "@heroui/react";
import { useDispatch, useSelector } from "react-redux";
import FilterSortDrawer from "./FilterSortDrawer";
import AuthDrawer from "./AuthDrawer";

const DRAWER_TITLES: Record<string, string> = {
    FilterSortDrawer: "Filter & Sort",
    AuthDrawer: "",
};

export function DrawerComponent() {
    const dispatch = useDispatch();
    const { isOpen, componentName, placement, className } = useSelector((state: RootState) => state.allCommonDrawer);

    const overlayState = useOverlayState({
        isOpen,
        onOpenChange: (open) => {
            if (!open) dispatch(closeDrawer());
        },
    });

    const renderComponent = () => {
        switch (componentName) {
            case "FilterSortDrawer":
                return <FilterSortDrawer />;
            case "AuthDrawer":
                return <AuthDrawer />;
            default:
                return null;
        }
    };

    const title = componentName ? (DRAWER_TITLES[componentName] ?? "") : "";

    return (
        <Drawer state={overlayState}>
            <Button aria-hidden="true" aria-label="drawer trigger" isDisabled className="sr-only absolute" />
            <Drawer.Backdrop isDismissable className="z-200">
                <Drawer.Content placement={placement} className="z-200">
                    <Drawer.Dialog className={`${className}`}>
                        <Drawer.Header>
                            <Drawer.Heading className="text-xl tracking-wide">
                                {title}
                            </Drawer.Heading>
                            <Drawer.CloseTrigger aria-label="Close" className="cursor-pointer" />
                        </Drawer.Header>
                        <Drawer.Body className="p-0 overflow-hidden flex flex-col">
                            {renderComponent()}
                        </Drawer.Body>
                    </Drawer.Dialog>
                </Drawer.Content>
            </Drawer.Backdrop>
        </Drawer>
    );
}
